<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Bank/Cash Transaction without/Invalid CashFlow Account                
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="5">
                        <b-input-group>
                            <b-input-group-prepend><span class="pt-2 mr-2">Trx. Date Range</span></b-input-group-prepend>
                            <b-form-input v-model="filterProc.tgl1" type="date" placeholder="from date" @change="updateTgl2"></b-form-input>
                            <b-form-input v-model="filterProc.tgl2" type="date" placeholder="until date" @change="updateTgl1" class="ml-1 mr-2"></b-form-input>
                            <b-input-group-append>
                                <button class="btn btn-success ml-2" @click="process()"><i class="fa fa-play"></i>Process</button>
                            </b-input-group-append>
                        </b-input-group>
                </b-col>
            </b-row >
            <b-row v-if="(filterShow=='Hide')">
              <b-col lg="5">
                  <b-input-group size="sm" class="ml-1">
                      <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                        <b-input-group-prepend> <span class="pr-2">
                            <b> {{ filterShow }}</b>  Filter </span>
                        </b-input-group-prepend>
                      <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                  </b-input-group>
              </b-col>
              <b-col lg="7">
                  <b-input-group size="sm" >
                      <b-input-group-prepend > <span class="p-1">Filter On:</span>
                      </b-input-group-prepend>
                      <b-form-checkbox-group v-model="filterOn" class="mt-1">
                          <b-form-checkbox value="uraian">Description</b-form-checkbox>
                          <b-form-checkbox value="reff">Invoice/Reff</b-form-checkbox>
                          <b-form-checkbox value="nomor">Trx. Number</b-form-checkbox>
                          <b-form-checkbox value="nilai_lcy">Trx. Value (LCY)</b-form-checkbox>
                          <b-form-checkbox value="nilaibank">Trx. Value (FCY)</b-form-checkbox>
                      </b-form-checkbox-group>
                  </b-input-group>
                  <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-3">
                <b> {{ filterShow }}</b>  Filter
              </b-form-checkbox>
            </b-row>

        <b-table
          class="mb-0"
          ref="tableOri"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          style="font-size:smaller;"
          :items="rptLines"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(tanggal)="data">{{ data.item.tanggal | moment("D-MMM-YY") }}</template>
          <template v-slot:cell(nomor)="data">
                <b-link @click.stop="printJv(data.item)">{{data.item.nomor}}</b-link>
          </template>
          <template v-slot:cell(nilaibank)="data">{{ data.item.matauang}} {{ data.item.nilaibank | numFormat }}</template>
          <template v-slot:cell(umasuk)="data">{{ data.item.umasuk | numFormat }}</template>
          <template v-slot:cell(ukeluar)="data">{{ data.item.ukeluar | numFormat }}</template>
            <template v-slot:cell(namacash)="data">
            <span v-if="(data.item.namacash)" class="ml-2"> {{ data.item.kodecash}} - {{ data.item.namacash}}</span>
            <div style="float:right;">
                <a href="javascript:void(0)" @click.stop="edit(data.item)"><i class="fa fa-pencil"></i></a>|
                <a href="javascript:void(0)" class="text-danger" @click.stop="clear(data.item)"><i class="fa fa-trash"></i></a>
            </div>
            </template>          
        </b-table>
        <b-row class="mt-2">
          <b-col cols="5">
            <div style="font-weight: bold;" class="ml-1">
              Total Nett Value : {{uanguser}}
              <div
                style="text-align:right; border:1px solid silver; width:200px;height:40px;border-top: 1px solid #000 ;border-bottom: 2px solid #000; background: #e6e6e6; display:inline;"
                class="pl-2 pt-2 pr-2"
              >{{subtotal.totalModul | numFormat('0,0.00')}}</div>

                    <span class="ml-2" style="font-weight: normal;">Showing {{ (tblLcy.page - 1) * tblLcy.limit + 1 }} to </span>
                    <span v-if="tblLcy.page * tblLcy.limit > tblLcy.total" style="font-weight: normal;">{{tblLcy.total}} of</span>
                    <span v-else style="font-weight: normal;">{{ tblLcy.page * tblLcy.limit }} of</span>
                    {{ tblLcy.total }} entries

            </div>
          </b-col>
          <b-col cols="3" style="text-align: center">
            <div>
                <span class="pt-1 pr-2">Limit per page</span>
                <input type="number" style="width:80px;" v-model="tblLcy.limit" class="mr-2" />
            </div>
          </b-col>
          <b-col cols="4">
                <b-pagination
                  align="right"
                  :total-rows="tblLcy.total"
                  :per-page="tblLcy.limit"
                  v-model="tblLcy.page"
                ></b-pagination>
          </b-col>
        </b-row>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true">
                <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData"></lku-cashflow>
        </b-modal>        
    </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            tr.edited {
              background: #f7cac9;
            }
            tr.selected {
              background:#a0e2f7;
            }
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px double #000 !important;
                background: #e6e6e6 !important;
            }

            tbody tr:hover {
                background-color: rgba(0, 0, 0, 0.05) !important;
                cursor: default;
            }

        }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import myNumber from "../../components/my-number";
import lkuCashflow from "../lookup/lkuCashflowLazzy";
import cashflow from "../../apis/cashflow";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filterProc: {
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      filterProc: {kodeaw:'', tgl1:'',tgl2:''},
      isLoading: false,
      horizontal: true,
      reportUrl: null,
      showReport:false,
      tahun:moment(this.$store.state.user.tglaktif).format('YYYY'),
      lkuCashflowData:{},
      lkuCashflowShow:false,
      lkuCashflowCaller:'kodeaw',
      showList:true,
       uanguser:this.$store.state.user.matauang,
      model: {},
      rptLines: [],
      subtotal: {},
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "tanggal",
            label: "Trx. Date",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nomor",
            label: "Trx. Number",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true
          },
          {
            key: "reff",
            label: "Invoice/Reff",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "namatable",
            label: "Trx.Source",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "createby",
            label: "Input By",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "nilaibank",
            label: "Value Original",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "umasuk",
            label: "Debit",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "ukeluar",
            label: "Credit",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "namacash",
            label: "CashFlow Account",
            thStyle: "width:330px",
            sortable: true
          },

        ]
      },
      filterShow: "Show",
      filter: null,
      filterOn: [],
    };
  },
components: { Loading, myNumber, lkuCashflow },  
computed:{
    dimension(){
      return this.$store.state.dimension;
    },
    invalidFilter() {
      this.$v.filterProc.$touch();
      return this.$v.filterProc.$invalid;
    },
  },
created: async function (){
    if (this.$route.params.tgl1 && this.$route.params.tgl2) {
        this.filterProc.tgl1=this.$route.params.tgl1;
        this.filterProc.tgl2=this.$route.params.tgl2;
        this.process();
    } else {
         var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.filterProc.tgl1=`${tgl2.format('YYYY-MM')}-01`;
        this.filterProc.tgl2=tgl2.format('YYYY-MM-DD');
        this.tahun=tgl2.format('YYYY');
    }
},
methods:{
    updateTgl1: function() {
        var tgl2 = moment(this.filterProc.tgl2, 'YYYY-MM-DD');
        if (!this.filterProc.tgl1){
            this.filterProc.tgl1=`${tgl2.format('YYYY-MM')}-01`;
            this.tahun=tgl2.format('YYYY');
            this.$forceUpdate();
        } else {
            var tgl1 = moment(this.filterProc.tgl1, 'YYYY-MM-DD');
            if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
                this.filterProc.tgl1=`${tgl2.format('YYYY')}-01-01`;
                this.tahun=tgl2.format('YYYY');
                this.$forceUpdate();
            }
        }
    },
    updateTgl2: function() {
        var tgl1 = moment(this.filterProc.tgl1, 'YYYY-MM-DD');
        if (!this.filterProc.tgl2){
            this.filterProc.tgl2=`${tgl1.format('YYYY')}-12-31`;
            this.tahun=tgl1.format('YYYY');
            this.$forceUpdate();
        } else {
            var tgl2 = moment(this.filterProc.tgl2, 'YYYY-MM-DD');
            if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
                this.filterProc.tgl2=`${tgl1.format('YYYY')}-12-31`;
                this.tahun=tgl1.format('YYYY');
                this.$forceUpdate();
            }
        }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                this.rptLines= await cashflow.cfinvalidacc(this.filterProc);
                this.tblLcy.total = this.rptLines.length;
                this.subtotal.totalModul = this.rptLines.reduce((a, b) => a + ((b.umasuk||0)-(b.ukleuar||0)), 0);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            console.log('model obj : ',this.filterProc);
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const response = await cashflow.cfinvalidaccexport(this.filterProc);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    confirmAction: function(data) {
        if (this.model.tablekey === data.tablekey) {
            this.model.selected = 1;
            this.editAccCf();
        } else {
            if (this.model) this.model.selected = 0;
            this.model=data;
            this.model.selected = 1;
            this.$forceUpdate();
        }
    },
    editAccCf: async function() {
        if (this.model.selected){
            this.showLkuCoa('model');
        } else {
            toastr.warn('Please select a row that want to be Edit CF Acc.!');
        }
    },
    async clearkodecash(){
        if (this.model.selected){
            try {
                this.model.kodecash = '';
                this.model.namacash = '';
                // this.model.uraian= this.model.uraian.split(' <> ')[0]+' <> CF Account Cleared';
                this.model.edited = 1;
                this.model.selected = 0;
                await cashflow.clearkodecash(this.model);
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
        } else {
            toastr.warn('Please select a row that want to be cleared!');
        }
    },
    edit: function(data) {
            if (this.model) this.model.selected = 0;
            this.model=data;
            this.model.selected = 1;
            // this.$forceUpdate();
            this.showLkuCoa('model');
    },    
    clear: function(data) {
            if (this.model) this.model.selected = 0;
            this.model=data;
            this.model.selected = 1;
            // this.$forceUpdate();
            this.clearkodecash();
    },    
    printJv: async function(data){
        // this.showConfirmAction=false;
        // this.showList=true;
       if (data.nomor !== '') {
          try {
              toastr.info('PRINT VOUCHER in progress...');
                this.showReport=true;
              this.reportUrl= await cashflow.printjv(data);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } 
    },
    showLkuCoa(callerObj)
    {
      this.lkuCashflowShow=true;
      this.lkuCashflowCaller=callerObj;
    },
    async onSelectLkuCashflow(lkuData) {
        this.lkuCashflowData=lkuData;
        this.lkuCashflowShow=false;
        switch (this.lkuCashflowCaller) {
            case 'kodeaw':
                this.filterProc.kodeawinfo = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
                this.filterProc.kodeaw = lkuData.selected.kodecash;
                break;        
        //     case 'kodeak':
        //         this.filterProc.kodeakinfo = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
        //         this.filterProc.kodeak = lkuData.selected.kodecash;
        //         break;
            default:
                if (this.model.kodecash !== lkuData.selected.kodecash) {
                    // this.model.cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
                    this.model.namacash = lkuData.selected.namacash;
                    this.model.kodecash = lkuData.selected.kodecash;
                    // this.model.uraian= this.model.uraian.split(' <> ')[0]+' <> CF Account edited to : '+ lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
                    this.model.edited = 1;
                    this.model.selected = 0;
                    try {
                        await cashflow.changekodecash(this.model);
                    } catch (error) {
                        if (error.message) {
                            toastr.error(error.message);
                        } else {
                            toastr.error(JSON.stringify(error));
                        }
                    }
                } 
                break;
        }
        this.lkuCashflowShow=false;
    },
    close(){
      router.push({name: "treasury.home"});
    }
  }
};
</script>
